export default "__VITE_ASSET__DnJuecyx__"